module.exports = __webpack_public_path__ + "assets/5916984fb71606613ecd654c0b4692ed.mp3";